module.exports = __webpack_public_path__ + "static/media/FooterBanner.a830cbc5.png";